'use client';
import { jsx } from '@emotion/react/jsx-runtime';
import { forwardRef, Fragment } from 'react';
import { Box } from '@s7/base';
import { useProps } from '@s7/styles';
import { IDENT_INPUT } from '../Input/Input.contract.js';
import { InputRootProvider } from './InputRoot.context.js';
import { defaultProps, IDENT_INPUT_ROOT } from './InputRoot.contract.js';
import useStyles from './InputRoot.styles.js';
import { InputHint } from './InputHint/InputHint.js';
import { InputLabel } from './InputLabel/InputLabel.js';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var InputRoot = /*#__PURE__*/ forwardRef(function(_param, ref) {
    var _param___withStaticSelectors = _param.__withStaticSelectors, __withStaticSelectors = _param___withStaticSelectors === void 0 ? false : _param___withStaticSelectors, props = _object_without_properties_loose(_param, [
        "__withStaticSelectors"
    ]);
    var _useProps = useProps(IDENT_INPUT, defaultProps, props), _useProps_ = _useProps[0], className = _useProps_.className, label = _useProps_.label, children = _useProps_.children, id = _useProps_.id, hint = _useProps_.hint, labelElement = _useProps_.labelElement, labelProps = _useProps_.labelProps, hintProps = _useProps_.hintProps, InputContainer = _useProps_.inputContainer, elementsOrder = _useProps_.elementsOrder, state = _useProps_.state, states = _useProps_.states, disabled = _useProps_.disabled, required = _useProps_.required, spacing = _useProps_.spacing, sxs = _useProps[1], others = _object_without_properties_loose(_useProps[0], [
        "className",
        "label",
        "children",
        "id",
        "hint",
        "labelElement",
        "labelProps",
        "hintProps",
        "inputContainer",
        "elementsOrder",
        "state",
        "states",
        "disabled",
        "required",
        "spacing"
    ]);
    var _useStyles = useStyles({
        spacing: spacing
    }, _extends({}, sxs, {
        __withStaticSelectors: __withStaticSelectors
    }), IDENT_INPUT_ROOT), classes = _useStyles[0], cx = _useStyles[1];
    var InputWrapper = InputContainer ? InputContainer : Fragment;
    return /*#__PURE__*/ jsx(InputRootProvider, {
        value: {
            state: state,
            states: states,
            disabled: disabled,
            required: required,
            size: sxs.size,
            labelElement: labelElement
        },
        children: /*#__PURE__*/ jsx(Box, _extends({
            ref: ref,
            className: cx(classes.root, className)
        }, others, {
            children: elementsOrder == null ? void 0 : elementsOrder.map(function(part) {
                switch(part){
                    case "label":
                        if (!label) {
                            return null;
                        }
                        return label && /*#__PURE__*/ jsx(InputLabel, _extends({}, sxs, labelProps, {
                            __withStaticSelectors: __withStaticSelectors,
                            htmlFor: id,
                            id: id ? "" + id + "-label" : undefined,
                            labelElement: labelElement,
                            size: (labelProps == null ? void 0 : labelProps.size) || sxs.size,
                            children: label
                        }), "label");
                    case "hint":
                        {
                            var _states_state;
                            if (!hint) {
                                return null;
                            }
                            var hintColor = disabled ? hintProps == null ? void 0 : hintProps.color : (states == null ? void 0 : (_states_state = states[state]) == null ? void 0 : _states_state.color) || (hintProps == null ? void 0 : hintProps.color);
                            return hint && /*#__PURE__*/ jsx(InputHint, _extends({}, sxs, hintProps, {
                                __withStaticSelectors: __withStaticSelectors,
                                id: (hintProps == null ? void 0 : hintProps.id) || (id ? "" + id + "-hint" : hintProps == null ? void 0 : hintProps.id),
                                color: hintColor,
                                size: (hintProps == null ? void 0 : hintProps.size) || sxs.size,
                                children: hint
                            }), "hint");
                        }
                    case "input":
                        return /*#__PURE__*/ jsx(InputWrapper, {
                            children: children
                        }, "input");
                    default:
                        return null;
                }
            })
        }))
    });
});
InputRoot.displayName = "Input.Root";

export { InputRoot };
